import { flexRowCenterCenter } from '../../../common/styles/flex';
import { SITE_VARIABLES } from '../../../common/styles/variables';
import { CTA_BUTTON_HEIGHT, CTA_BUTTON_MARGIN_RIGHT } from '../controlsPlugin.constants';
import { PlayerSizesTypes } from '../../../common/store/store.types';

interface StylesObject {
  arrowUpStyle: { [key: string]: any };
  dotStyle: { [key: string]: any }[];
  titleStyle: { [key: string]: any }[];
  buttonStyle: { [key: string]: any }[];
}

const getArrowUpStyle = playerSize => {
  const style = [];
  style.push({
    marginLeft: '8px',
    marginRight: '18px',
  });
  if (playerSize === 'medium') {
    style.push({ display: 'none' });
  }
  return style;
};

const getDotStyle = playerSize => {
  const style = [];
  style.push({
    display: 'inline-block',
    backgroundColor: 'white',
    width: '4px',
    height: '4px',
    borderRadius: '50%',
    marginLeft: '16px',
    marginRight: '8px',
  });
  if (playerSize === 'medium') {
    style.push({ display: 'none' });
  }
  return style;
};

const getTitleStyle = playerSize => {
  const style = [];
  style.push({
    color: 'white',
    fontFamily: SITE_VARIABLES.TEXT_FONT_FAMILY.LATO,
    fontSize: SITE_VARIABLES.FONT_SIZE.TINY,
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
  });
  if (playerSize === 'medium') {
    style.push({ margin: '0px 10px' });
  }
  return style;
};

const getButtonStyle = (isRecirculationVideo: boolean, playerSize: PlayerSizesTypes, isHovered: boolean, showCta: boolean) => {
  const style = [];
  style.push({
    ...flexRowCenterCenter,
    position: 'absolute',
    height: CTA_BUTTON_HEIGHT.LARGE_AND_EXTRA_LARGE,
    width: 'fit-content',
    borderRadius: '17px',
    textDecoration: 'none',
    pointerEvents: 'auto',
    backgroundImage: 'linear-gradient(344deg, #3888ff 50%, #00a3ff)',
  });
  switch (playerSize) {
    case 'medium':
      style.push({
        height: CTA_BUTTON_HEIGHT.MEDIUM,
        right: `${CTA_BUTTON_MARGIN_RIGHT.MEDIUM}px`,
        top: !isRecirculationVideo ? '6px' : 'unset',
      });
      break;
    case 'large':
      style.push({

        right: `${CTA_BUTTON_MARGIN_RIGHT.LARGE}px`,
        top: !isRecirculationVideo ? '9px' : 'unset',
      });
      break;
    case 'extraLarge':
      style.push({
        right: `${CTA_BUTTON_MARGIN_RIGHT.EXTRA_LARGE}px`,
        top: !isRecirculationVideo ? '12px' : 'unset',
      });
      break;
    default:
      break;
  }
  if (isHovered) {
    style.push({ backgroundImage: 'linear-gradient(352deg, #4190ff 50%, #1ac7ff)' });
  }
  if (!showCta) {
    style.push({ display: 'none' });
  }

  return style;
};

export const getCtaButtonStyleObject = (showCta: boolean, isHovered: boolean, playerSize: PlayerSizesTypes, isRecirculationVideo: boolean): StylesObject => {
  return {
    arrowUpStyle: [
      getArrowUpStyle(playerSize),
    ],
    dotStyle: [
      getDotStyle(playerSize),
    ],
    titleStyle: [
      getTitleStyle(playerSize),
    ],
    buttonStyle: [
      getButtonStyle(isRecirculationVideo, playerSize, isHovered, showCta),
    ],
  };
};
